import { GET_AVAILABLE_SYSTEMS } from '../api/lelyBackend/config';
import api from './api';

export type System = {
  id: string;
  description: string;
};

const availableSystemApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAvailableSystems: builder.query<System[], void>({
      query: () => GET_AVAILABLE_SYSTEMS,
    }),
  }),
});

export const { useGetAvailableSystemsQuery } = availableSystemApi;

export default availableSystemApi;
